"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "cervino": {
    "a3517b7a": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "skipSearch": false
    }],
    "mandorle": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "edee96df": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "skipSearch": false
    }],
    "morrilli": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "70f890cb": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "skipSearch": false
    }],
    "razzani": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3855289f": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "skipSearch": false
    }],
    "vittoria": [{
      "hkey": "69c806d5",
      "slug": "cervino",
      "name": "Cervino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;